<template>
  <div class="custom-modal">
    <HolaconLottie v-if="loading == 'created'" class="w-100" key="create-loading" />
    <el-row v-else key="content-loading">
      <div class="modal-body">
        <upgrade-overlay v-if="false"></upgrade-overlay>
        <el-row v-else>
          <el-col :span="24" class="d-flex align-center justify-content-center">
            <lottie-player autoplay loop mode="normal" src="https://assets2.lottiefiles.com/packages/lf20_jkdsmf9r.json" style="width: 150px"></lottie-player>
          </el-col>
          <transition name="el-fade-in" mode="out-in">
            <el-col :span="24" class="text-center" v-if="excellDisplay == null" key="title">
              <p>{{ $t("components.excelImportAndExport.infoMsg1") }}</p>
              <p>{{ $t("components.excelImportAndExport.infoMsg2") }}</p>
            </el-col>
            <el-col :span="24" class="export-display cursor-pointer" key="file" v-else @click.native="openUrl(excellDisplay.url)">
              <div class="first">
                <div class="total">{{ $t("components.excelImportAndExport.total") }} {{ excellDisplay.total }}</div>
                <div class="file-name">
                  <span class="file">{{ excellDisplay.fileName }}</span>
                  <i class="fa fa-download"></i>
                </div>
              </div>
            </el-col>
          </transition>

          <!-- <el-progress :percentage="50" status="success"></el-progress> -->
        </el-row>
      </div>
    </el-row>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeMe')">{{ $t("contentManagement.speakers.speakerAddUpdate.close") }}</el-button>
        <!-- <template>
            <el-popconfirm :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
              <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t('contentManagement.speakers.speakerAddUpdate.delete') }}</el-button>
            </el-popconfirm>
          </template> -->
      </div>
      <div class="right-buttons" v-if="excellDisplay == null">
        <el-button type="primary" @click="startExporting" :loading="loading == true">{{ $t("components.excelImportAndExport.start") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["payload"],
  name: "ExcelExport",
  data() {
    return {
      excellDisplay: null,
      loading: false,
      timeout: null
    };
  },
  async created() {
    this.loading = "created";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.loading = false;
    }, 500);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    }
  },
  methods: {
    openUrl(url) {
      window.open(url, "_blank");
    },
    async startExporting() {
      this.loading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("exportXlscx", this.payload);
        if (!res.data.alert.hasError) {
          this.excellDisplay = res.data.data;
        }
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.export-display {
  background-color: #03658c;
  padding: 1rem;
  border-radius: 1rem;
  display: flex;
  gap: 10px;
  flex-direction: column;

  .first {
    display: flex;
    gap: 10px;

    .total {
      background-color: white;
      padding: 10px;
      border-radius: 1rem;
      font-weight: bold;
      text-align: center;
      flex-shrink: 0;
    }

    .file-name {
      width: 100%;
      background-color: white;
      padding: 10px;
      border-radius: 1rem;
      font-weight: bold;
      text-align: center;
      position: relative;

      display: flex;
      align-items: center;

      .file {
        width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      i {
        position: absolute;
        right: 1rem;
        top: calc(~"50% - 9px");
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExcellExport.vue